import type { SVGProps } from 'react';

export function HippoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.263 4.163a.896.896 0 0 1 1.27 0l.646.645a4 4 0 0 1 .217-.008h1.2c.42 0 .822.086 1.185.244l.582-.581a.9.9 0 0 1 1.271 1.271l-.484.487c.285.458.45 1.002.45 1.58 0 .382.277.704.626.862A3 3 0 0 1 22.8 13.8V15c0 .33-.27.6-.6.6H21c-.33 0-.6-.27-.6-.6v-.6H18v.6c0 .33-.27.6-.6.6h-1.2c-.33 0-.6-.27-.6-.6v-.66a3 3 0 0 1-1.361-.671A3 3 0 0 1 13.2 11.4c0-.33-.27-.6-.6-.6s-.6.27-.6.6c0 1.676.982 3.12 2.4 3.795v.405c0 .664.536 1.2 1.2 1.2h1.2v2.4c0 .664-.536 1.2-1.2 1.2h-2.4c-.664 0-1.2-.536-1.2-1.2v-2.85a6.6 6.6 0 0 1-4.8 0v2.85c0 .664-.536 1.2-1.2 1.2H3.6c-.664 0-1.2-.536-1.2-1.2v-4.459l-.679 1.527a.9.9 0 1 1-1.642-.731L.9 13.683c.199-.446.3-.926.3-1.414a7.47 7.47 0 0 1 7.193-7.466L8.4 4.8h2.4c1.564 0 3.127.454 4.395.964q.097-.103.199-.195l-.132-.131a.896.896 0 0 1 0-1.272zM18 11.1c0-.499-.401-.9-.9-.9s-.9.401-.9.9.401.9.9.9.9-.401.9-.9m3.3.9c.499 0 .9-.401.9-.9s-.401-.9-.9-.9-.9.401-.9.9.401.9.9.9M18 7.8c0-.33-.27-.6-.6-.6s-.6.27-.6.6.27.6.6.6.6-.27.6-.6m1.8.6c.33 0 .6-.27.6-.6s-.27-.6-.6-.6-.6.27-.6.6.27.6.6.6" />
    </svg>
  );
}
